import { useEffect, useState } from "react";
import { HbrCancel } from "../MyCustomsvgicons";

const DeviceSelection = ({onDeviceSelected, closeDevicesPopup, deviceKind}) => {
    const [devices, setDevices] = useState([]);

    useEffect(()=>{
        const fetchDevices = async () => {
            const availableDevices = await navigator.mediaDevices.enumerateDevices();
            setDevices(availableDevices.filter(device => deviceKind === "video" ? device.kind === "videoinput" : device.kind === "audioinput"));
        }
        fetchDevices();
    },[deviceKind]);

    const handleDeviceSelect = (deviceId, kind) => {
        onDeviceSelected(deviceId, kind);
        closeDevicesPopup();
    }

    return ( 
        <div className="device-selection">
            <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>closeDevicesPopup()}/>
           
            {devices && devices.map(device => (
                <li key={device.deviceId} onClick={() => handleDeviceSelect(device.deviceId, device.kind)}>
                    {device.label || device.kind} ({device.deviceId})
                </li>
            ))}
            
        </div>
     );
}
export default DeviceSelection;